/**
 * components/BiorhythmMark.js — Ажилтны нэрийн ард гарах биоритмын тэмдэг.
 *
 * Backend-ийн `biorhythm` объектыг (Utils/biorhythm.py) шууд хүлээж авна:
 *   { days, level: "critical"|"low"|"ok", warn,
 *     cycles: {physical|emotional|intellectual: {percent, label, state}},
 *     critical: [], low: [] }
 *
 * Тэмдэг дээр дарахад/хулгана аваачихад 3 долгионы ГРАФИК гарна
 * (BiorhythmChart) — өнөөдрийн байрлал тодоор тэмдэглэгдсэн.
 *
 * ⚠ Биоритм нь ШИНЖЛЭХ УХААНЫ БАТАЛГААГҮЙ. Энэ тэмдэг нь ажилтныг ажлаас
 * хасах шалгуур БИШ — зөвхөн анхаарал татах сэрэмжлүүлэг. Тиймээс улаанаар
 * будаж айлгахгүй, жижиг тэмдэг + тайлбараар харуулна.
 */
import React from "react";
import { Popover } from "antd";

import BiorhythmChart from "./BiorhythmChart";

const LEVEL = {
  critical: { color: "#CA8A04", bg: "#FEF3C7", icon: "◐", label: "Эгзэгтэй өдөр" },
  low: { color: "#B45309", bg: "#FFF7ED", icon: "◔", label: "Түвшин бага" },
};

export default function BiorhythmMark({ bio, size = 13 }) {
  if (!bio || !bio.warn) return null;
  const cfg = LEVEL[bio.level];
  if (!cfg) return null;

  const content = (
    <div style={{ padding: 2 }}>
      <div style={{ fontWeight: 700, fontSize: 12.5, marginBottom: 6 }}>
        {cfg.label}
      </div>
      <BiorhythmChart bio={bio} />
      <div
        style={{
          marginTop: 8,
          paddingTop: 6,
          borderTop: "1px solid rgba(255,255,255,0.18)",
          fontSize: 10.5,
          opacity: 0.75,
          maxWidth: 300,
          lineHeight: 1.45,
        }}
      >
        Сэрэмжлүүлэг төдий — ажилд гаргах эсэх шийдвэрийн шалгуур биш.
        Долгион тэгийг огтолж буй өдрийг «эгзэгтэй» гэнэ.
      </div>
    </div>
  );

  return (
    <Popover content={content} trigger={["hover", "click"]} placement="right">
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 3,
          marginLeft: 6,
          padding: "0 5px",
          borderRadius: 4,
          background: cfg.bg,
          color: cfg.color,
          fontSize: size - 2,
          fontWeight: 700,
          lineHeight: 1.6,
          cursor: "pointer",
          verticalAlign: "middle",
        }}
      >
        {cfg.icon}
      </span>
    </Popover>
  );
}
